import moment from 'moment'

export default {
  getReferrals (VueApp, conId, callback) {
    let referrals = VueApp.$store.state.consumer.referrals
    let pageSize = referrals.perPage
    let page = referrals.currentPage

    VueApp.$sdk.get('/consumer/' + conId + '/referrals', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setReferralsCurrentPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setReferralsIsMax', true)
        }

        if (res.list.length) {
          let referral = res.list
          for (let i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('consumer/addReferrals', {
              firstName: referral[i].firstName,
              lastName: referral[i].lastName,
              email: referral[i].email,
              mobile: referral[i].phone,
              accountCreated: moment(referral[i].created, 'YYYY-MM-DD').format('MM/DD/YYYY'),
              lastTrx: referral[i].lastTrx,
              totalTrx: referral[i].lastTrx,
              id: referral[i].ID,
              type: referral[i].type,
              rating: referral[i].rating,
              referralCode: referral[i].referralCode,
              totalReferral: referral[i].totalReferral
            })
          }
        }
      }
      callback(res)
    })
  },
  getTotalReferrals (VueApp, conId, callback) {
    VueApp.$sdk.get('/consumer/' + conId + '/referrals', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setTotalReferrals', res.list.length)
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/referrals.js